import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {Carousel as AntCarousel} from 'antd';
import {useEffect, useRef, useState} from 'react';

import {RQGetAllHomeImagesAPI} from '../../../reactQuery/apis';

const Carousel = () => {
  const carouselRef = useRef(null);
  const [isWeb, setIsWeb] = useState(window.innerWidth > 768);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const {data = []} = RQGetAllHomeImagesAPI();

  const bannerSection = data
    .filter(item => item.isActive)
    .find(item => item.images?.length);

  const banners = bannerSection
    ? bannerSection.images.map((img, index) => ({
      id: `${bannerSection.id}-${index}`,
      image: img,
    }))
    : [];

  useEffect(() => {
    const handleResize = () => setIsWeb(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!banners.length) {return null;}

  return (
    <div className={'w-full relative'}>
      <div className={'overflow-hidden shadow-xl md:mt-2 mt-7'}>
        <AntCarousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={1900}
          effect={'fade'}
          dot
          beforeChange={(_, next) => setSelectedIndex(next)}
          className={'md:!h-[60vh] !h-[28vh]'}
        >
          {banners.map((item, index) => (
            <div key={item.id} className={'relative w-full h-full'}>
              <img  
                src={item.image}
                alt={`Slide ${index + 1}`}
                className={`w-full md:!h-[60vh] !h-[28vh] object-cover transition-all duration-700 ${
                  index === selectedIndex
                    ? 'opacity-100 scale-100'
                    : 'opacity-0 scale-105'
                }`}
              />
              <div className={'absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent'} />
            </div>
          ))}
        </AntCarousel>

        {isWeb && (
          <>
            <button
              onClick={() => carouselRef.current.prev()}
              className={'absolute top-1/2 left-4 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md'}
            >
              <LeftOutlined className={'text-xl'} />
            </button>

            <button
              onClick={() => carouselRef.current.next()}
              className={'absolute top-1/2 right-4 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md'}
            >
              <RightOutlined className={'text-xl'} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Carousel;
